let audioCtx = null;
let currentDrones = [];

function initAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (audioCtx.state === 'suspended') {
    audioCtx.resume();
  }
}

// SFX 1: Creepy wet mechanical eyelid opening slash
export const playEyelidOpenSFX = () => {
  initAudioContext();
  const now = audioCtx.currentTime;
  
  const osc1 = audioCtx.createOscillator();
  const gain1 = audioCtx.createGain();
  osc1.type = 'sawtooth';
  osc1.frequency.setValueAtTime(80, now);
  osc1.frequency.exponentialRampToValueAtTime(1200, now + 0.15);
  osc1.frequency.exponentialRampToValueAtTime(200, now + 0.6);
  
  const filter = audioCtx.createBiquadFilter();
  filter.type = 'peaking';
  filter.Q.setValueAtTime(15, now);
  filter.frequency.setValueAtTime(300, now);
  filter.frequency.exponentialRampToValueAtTime(3000, now + 0.2);

  gain1.gain.setValueAtTime(0.001, now);
  gain1.gain.linearRampToValueAtTime(0.25, now + 0.05);
  gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.7);

  osc1.connect(filter);
  filter.connect(gain1);
  gain1.connect(audioCtx.destination);
  
  osc1.start(now);
  osc1.stop(now + 0.7);
};

// SFX 2: Corrupted radioactive blast white-out explosion
export const playWhiteoutExplosionSFX = () => {
  initAudioContext();
  const now = audioCtx.currentTime;
  const duration = 1.8;

  const bufferSize = audioCtx.sampleRate * duration;
  const buffer = audioCtx.createBuffer(1, bufferSize, audioCtx.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) {
    data[i] = Math.random() * 2 - 1;
  }

  const noiseNode = audioCtx.createBufferSource();
  noiseNode.buffer = buffer;

  const subOsc = audioCtx.createOscillator();
  const subGain = audioCtx.createGain();
  subOsc.type = 'triangle';
  subOsc.frequency.setValueAtTime(90, now);
  subOsc.frequency.linearRampToValueAtTime(30, now + duration);

  subGain.gain.setValueAtTime(0.4, now);
  subGain.gain.exponentialRampToValueAtTime(0.001, now + duration);

  const noiseFilter = audioCtx.createBiquadFilter();
  noiseFilter.type = 'lowpass';
  noiseFilter.frequency.setValueAtTime(200, now);
  noiseFilter.frequency.exponentialRampToValueAtTime(8000, now + 0.4);
  noiseFilter.frequency.exponentialRampToValueAtTime(200, now + duration);

  const noiseGain = audioCtx.createGain();
  noiseGain.gain.setValueAtTime(0.01, now);
  noiseGain.gain.linearRampToValueAtTime(0.35, now + 0.2);
  noiseGain.gain.exponentialRampToValueAtTime(0.001, now + duration);

  noiseNode.connect(noiseFilter);
  noiseFilter.connect(noiseGain);
  noiseGain.connect(audioCtx.destination);

  subOsc.connect(subGain);
  subGain.connect(audioCtx.destination);

  noiseNode.start(now);
  subOsc.start(now);
  
  noiseNode.stop(now + duration);
  subOsc.stop(now + duration);
};

// Dark Drone Router Binds
export const transitionSoundscape = (pageKey) => {
  initAudioContext();
  const now = audioCtx.currentTime;

  currentDrones.forEach(d => {
    try {
      d.gainNode.gain.exponentialRampToValueAtTime(0.001, now + 0.3);
      setTimeout(() => d.oscNode.stop(), 400);
    } catch (e) {}
  });
  currentDrones = [];

  if (pageKey === 'mute_void' || pageKey === 'splash' || pageKey === 'login') return;

  let f1 = 55; 
  let f2 = 110;
  let type = 'triangle';

  if (pageKey === 'movies') {
    f1 = 45; 
    f2 = 90;
    type = 'sine';
  } else if (pageKey === 'admin') {
    f1 = 62; 
    f2 = 124;
    type = 'sawtooth';
  }

  const osc1 = audioCtx.createOscillator();
  const gain1 = audioCtx.createGain();
  osc1.type = type;
  osc1.frequency.setValueAtTime(f1, now);

  const osc2 = audioCtx.createOscillator();
  const gain2 = audioCtx.createGain();
  osc2.type = 'sine';
  osc2.frequency.setValueAtTime(f2, now);

  const maxGain = type === 'sawtooth' ? 0.015 : 0.12;

  gain1.gain.setValueAtTime(0.001, now);
  gain1.gain.linearRampToValueAtTime(maxGain, now + 1.5);
  gain2.gain.setValueAtTime(0.001, now);
  gain2.gain.linearRampToValueAtTime(maxGain * 0.4, now + 1.5);

  osc1.connect(gain1);
  gain1.connect(audioCtx.destination);
  osc2.connect(gain2);
  gain2.connect(audioCtx.destination);

  osc1.start(now);
  osc2.start(now);

  currentDrones.push({ oscNode: osc1, gainNode: gain1 }, { oscNode: osc2, gainNode: gain2 });
};

// SFX: Cyberpunk key click — sharp synthetic tick on every input/button interaction
export const playKeyClick = () => {
  initAudioContext();
  const now = audioCtx.currentTime;

  // Sharp transient click body
  const osc = audioCtx.createOscillator();
  const gain = audioCtx.createGain();
  osc.type = 'square';
  osc.frequency.setValueAtTime(1200, now);
  osc.frequency.exponentialRampToValueAtTime(300, now + 0.04);
  gain.gain.setValueAtTime(0.18, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.045);

  // Subtle high-freq shimmer on top
  const shimmer = audioCtx.createOscillator();
  const shimmerGain = audioCtx.createGain();
  shimmer.type = 'sine';
  shimmer.frequency.setValueAtTime(4800, now);
  shimmerGain.gain.setValueAtTime(0.06, now);
  shimmerGain.gain.exponentialRampToValueAtTime(0.001, now + 0.03);

  osc.connect(gain);
  gain.connect(audioCtx.destination);
  shimmer.connect(shimmerGain);
  shimmerGain.connect(audioCtx.destination);

  osc.start(now);
  osc.stop(now + 0.05);
  shimmer.start(now);
  shimmer.stop(now + 0.03);
};
